module.exports = __webpack_public_path__ + "img/20220823.a4e17fd3.png";